import React from "react";
import { Navigate } from "react-router-dom";

// Client-side redirect for legacy URLs (redirects table).
export default function RedirectTo({ to }) {
  return <Navigate to={to} replace />;
}

// Path map documented for server/DNS-level 301s at launch:
// /carriere -> /carrieres, /gallery -> /galerie, /contact-us -> /contact,
// /accueil -> /, /services-en -> /services
export const REDIRECTS = {
  "/carriere": "/carrieres",
  "/gallery": "/galerie",
  "/contact-us": "/contact",
  "/accueil": "/",
  "/services-en": "/services",
};
